import Component from '@glimmer/component'
import { service } from '@ember/service'
import { format, compareDesc } from 'date-fns'
import type { IntlService } from 'ember-intl'
import type SchoolRollover from 'teacher-ui-client/models/school-rollover'

interface Signature {
  Element: HTMLTableElement
  Args: {
    rollovers: SchoolRollover[]
  }
}

export class RolloverHistoryTable extends Component<Signature> {
  @service intl!: IntlService

  get rows() {
    // Sort the rollovers and use only the latest 3
    const displayCount = 3
    const latestRollovers = [...this.args.rollovers]
      .sort((a, b) => compareDesc(a.updatedAt, b.updatedAt))
      .slice(0, displayCount)

    return latestRollovers.map((rollover) => {
      const updatedAtFormatted = format(rollover.updatedAt, this.intl.t('dateFormats.dateFns.d MMM yyyy'))
      const subscriptionTypeFormatted = this.intl.t(rollover.subscriptionType)
      const { teacherFullName } = rollover

      return { updatedAtFormatted, subscriptionTypeFormatted, teacherFullName }
    })
  }

  <template>
    <table data-test-rollover-history-table ...attributes>
      <tbody>
        {{#each this.rows as |row index|}}
          <tr data-test-tr={{index}}>
            <td class="table-box table-box-cell bg-juicy-orange-50 w-1/3" data-test-td="updatedAt">
              {{row.updatedAtFormatted}}
            </td>
            <td class="table-box table-box-cell bg-juicy-orange-50 w-1/3" data-test-td="subType">
              {{row.subscriptionTypeFormatted}}
            </td>
            <td class="table-box table-box-cell bg-juicy-orange-50 w-1/3" data-test-td="teacherName">
              {{row.teacherFullName}}
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </template>
}

export default RolloverHistoryTable
